module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/web/game/management/job-market/job-market.component.css
// module id = ./src/app/web/game/management/job-market/job-market.component.css
// module chunks = main